import React from "react"
import { Helmet } from "react-helmet"

export interface CollectionPageSchemaProps {
  description?: string
  name: string
  numberOfItems?: number
  url?: string
}

/**
 * CollectionPageSchema component for adding CollectionPage structured data (JSON-LD)
 * Use this on product listing pages (PLPs) to help search engines understand
 * the collection/category structure.
 *
 * @see https://schema.org/CollectionPage
 */
export const CollectionPageSchema: React.FC<CollectionPageSchemaProps> = ({
  description,
  name,
  numberOfItems,
  url,
}) => {
  const schema = {
    "@context": "https://schema.org/",
    "@type": "CollectionPage",
    name,
    ...(description && { description }),
    ...(url && { url }),
    ...(numberOfItems && {
      mainEntity: {
        "@type": "ItemList",
        numberOfItems,
      },
    }),
  }

  return (
    <Helmet as={React.Fragment as any}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  )
}
